import Talk from 'talkjs'

export type ChatProviderProps = {
  children: React.ReactNode
}

export type CreateNewConversationProps = {
  professional: Talk.UserOptions
  patient?: Partial<Talk.UserOptions>
}

export type ChatContextType = {
  createNewConversation: (data: CreateNewConversationProps) => void
  conversation: Talk.ConversationBuilder | null
  destroyChatSession: () => void
  resetConversationSelected: () => void
}

export enum ChatRole {
  USER = 'user',
  PROFESSIONAL = 'professional',
}
